exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._26Kiu8wNY_6V_tSgg30GwW{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._26Kiu8wNY_6V_tSgg30GwW{border-top:1px solid \"[theme:neutralLight, default:#eaeaea]\"}._2usRkb4eZGCfQltOWBetU9{color:\"[theme:themePrimary, default:#0078D4]\";font-size:120px}._2THFjI9SRGgYOFHT9t7g-3{font-size:17px;font-weight:300}._309ruz_AIb5ijNgmrMZO4S{font-size:14px;font-weight:400}", ""]);

// exports
exports.locals = {
	"container": "_26Kiu8wNY_6V_tSgg30GwW",
	"emptyStateIcon": "_2usRkb4eZGCfQltOWBetU9",
	"emptyStateMessage": "_2THFjI9SRGgYOFHT9t7g-3",
	"emptyStateMessageSubtext": "_309ruz_AIb5ijNgmrMZO4S"
};